import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutCommunitySectionConfig, AboutCommunityMetricConfig } from 'src/environments/environment.interface';
import { AboutCommunityMetricCardComponent } from '../about-community-metric-card/about-community-metric-card.component';

@Component({
  selector: 'app-about-community-section',
  standalone: false,
  templateUrl: './about-community-section.component.html',
  styleUrls: ['./about-community-section.component.scss']
})
export class AboutCommunitySectionComponent {
  @Input() section: AboutCommunitySectionConfig | null = null;
}
